import { useCommonActionSubscriptions } from './actions/use-common-actions-subscriptions';
import { useNotificationActionSubscription } from './actions/use-notification-action-subscription';
import { useNotification } from './use-notification';

export const useScheduleWaitlistNotification = (onView: () => void) => {
  const { create, remove } = useNotification<'schedule-waitlist'>();

  useCommonActionSubscriptions('schedule-waitlist');
  useNotificationActionSubscription('schedule-waitlist', 'view', ({ notification }) => {
    onView();
    remove(notification.id);
  });

  return {
    create,
    remove,
  };
};
